export const formEndingTypes = {
  DEFAULT: 'DEFAULT',
  ANSWERBASED: 'ANSWERBASED',
  SCOREBASED: 'SCOREBASED',
  VISITORBASED: 'VISITORBASED'
}
